<template>
  <div>
    <Tree
      :data="treeData"
      @on-select-change="selectData"
      @on-check-change="checkChange"
      :render="renderContent"
      :show-checkbox="showCheckbox"
    ></Tree>
  </div>
</template>
<script>
export default {
  props: ["showCheck", "ids"],

  data: function () {
    return {
      treeData: [],
      showCheckbox: false,
    };
  },

  created: function () {
    this.showCheckbox = this.showCheck == null ? false : this.showCheck;
    this.getListTree();
  },

  methods: {
    getListTree() {
     
      var parm = { ids: [] };
      if (this.ids) {
        parm.ids = this.ids;
      }
      this.$api.post("/organ/getListTree", parm).then((rsp) => {
        if (rsp != false) {
          this.treeData = rsp.data;
        }
      });
    },

    selectData: function (data) {
      this.$emit("selectTreeData", data);
    },
    checkChange: function (data, CurrentSelect) {
      this.$emit("checkChange", data);
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "8px",
              },
            }),
            h("span", data.title),
          ]),
          h("span", {
            style: {
              display: "inline-block",
              float: "right",
              marginRight: "32px",
            },
          }),
        ]
      );
    },
  },
};
</script>
<style scoped>
</style>